import { render, staticRenderFns } from "./hl7-settings.vue?vue&type=template&id=718d58ef"
import script from "./hl7-settings.vue?vue&type=script&lang=js"
export * from "./hl7-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports